
<template>
  <div>
    <!-- <el-button @click="show = !show">Click Me</el-button> -->

    <div
      style="
        display: flex;
        font-size: 25px;
        height: 50px;
        color: #919191;
        font-family: cursive;
      "
    >
      <transition name="el-fade-in-linear">
        <i v-show="show" @click="back" class="el-icon-back"></i>
      </transition>
      <transition name="el-fade-in-linear">
        <div style="margin-left: 10px" v-show="show" class="transition-box">
          新增文章
        </div>
      </transition>
    </div>
    <div>
      <el-form
        :label-position="'right'"
        label-width="80px"
        :model="formDataAdd"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题">
              <el-input
                placeholder="请输入文章标题"
                v-model="formDataAdd.newsName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="文章Id">
              <el-input
                placeholder="请输入文章Id"
                v-model="formDataAdd.newsId"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跳转路径">
              <el-input
                placeholder="请输入文章跳转路径"
                v-model="formDataAdd.url"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="点赞数">
              <el-input
                type="number"
                placeholder="请输入点赞数"
                v-model="formDataAdd.ups"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="发布时间">
              <!-- <el-input v-model="formDataAdd.releaseTime"></el-input> -->
              <el-date-picker
                class="dataPicker"
                @change="changeTime"
                v-model="formDataAdd.time"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="发布状态">
              <el-select
                class="state"
                @change="changeState"
                v-model="formDataAdd.states"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in stateList"
                  :key="item.state"
                  :label="item.contentName"
                  :value="item.state"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>

        <!-- <el-form-item label="文章推送公司">
          <el-select
            class="company"
            @change="changeCompany"
            v-model="formDataAdd.name_id"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in conpmanyOptions"
              :key="item.name_id"
              :label="item.name"
              :value="item.name_id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="上传封面图">
          <el-upload
            class="avatar-uploader"
            v-model="imageUrl"
            action="http://task.95win.com/sqx_fast/alioss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              style="border-radius: 6px; width: 148px; height: 148px"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->

        <el-form-item label="文章内容">
          <!-- <el-input type="textarea" placeholder="请输入文章内容" class="content" v-model="formDataAdd.content"></el-input> -->
          <quill-editor
            class="ql-editor"
            v-model="formDataAdd.content"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
          >
          </quill-editor>
          <el-upload
            style="display: none"
            class="quill-picture-uploader"
            :action="imgsUploadUrl"
            :before-upload="bfUpload"
            :on-success="uploadSuccess"
          >
          </el-upload>
        </el-form-item>
      </el-form>

      <el-row style="text-align: right">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="commit">提交</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getCompanyList, addTbArticleList } from "../../api/newApis";
import { API_BASE } from "@/config/apiBase";
import Quill from "quill";
// import Parchment from "parchment";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { ImageDrop } from "quill-image-drop-module"; // 图片拖动组件引用
import ImageResize from "quill-image-resize-module"; // 图片缩放组件引用
Quill.register("modules/imageDrop", ImageDrop); // 注册
Quill.register("modules/imageResize", ImageResize); // 注册
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
  ["blockquote", "code-block"], //引用，代码块
  [{ header: 1 }, { header: 2 }], // 几级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序列表，无序列表
  [{ script: "sub" }, { script: "super" }], // 下角标，上角标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ direction: "rtl" }], // 文字输入方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 颜色选择
  [{ font: [] }], // 字体
  [{ align: [] }], // 居中
  ["clean"], // 清除样式,
  ["link", "image"], // 上传图片、上传视频
];
// let config = {
//   scope: Parchment.Scope.BLOCK,
//   whitelist: ["right", "center", "justify"],
// };
// let AlignStyle = new Parchment.Attributor.Style("align", "text-align", config);
// export { AlignStyle };
// var Align = Quill.import("attributors/style/align");
// Align.whitelist = ["right", "center", "justify"];
// Quill.register(Align, true);

export default {
  computed: {
    imgsUploadUrl() {
      return `${API_BASE}/imgs`;
    },
  },
  data() {
    return {
      imageUrl: "",
      urlList: [],
      // 富文本编辑器默认内容
      content: "",
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请在这里输入",
        theme: "snow", //主题 snow：有工具栏的；bubble：只有文本域的
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false,
        },
        modules: {
          imageDrop: true, //图片拖拽
          imageResize: {
            //放大缩小
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
          toolbar: {
            container: toolbarOptions, //工具栏
            handlers: {
              image: function (value) {
                //替换原图片上传功能
                if (value) {
                  document
                    .querySelector(".quill-picture-uploader input")
                    .click(); //核心
                } else {
                  this.quill.format("image", false);
                }
              },
              align: function (value) {
                const isCenter = value === "center";
                const range = this.quill.getSelection(true);
                this.quill.format("align", isCenter ? "center" : false);
                if (isCenter) {
                  this.quill.selection.shift(range.index + range.length);
                }
              },
            },
          },
        },
      },

      show: false,
      formDataAdd: {
        content: "",
        time: "",
        url: "",
        newsName: "",
      },
      nameArr: [],
      stateList: [
        {
          contentName: "草稿",
          state: "0",
        },
        {
          contentName: "发布",
          state: "1",
        },
      ],
      conpmanyOptions: null,
    };
  },
  // 注册组件
  components: {
    quillEditor,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getCompant();
    setTimeout(() => {
      this.show = !this.show;
    }, 500);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 图片上传
    handleAvatarSuccess1(file) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.imageUrl = file.data;
      setTimeout(() => {
        loading.close();
      }, 2000);
      // console.log(file);
    },
    //上传图片之前校验
    bfUpload(file) {
      console.log(file);
      if ("image/png" == file.type || "image/jpeg" == file.type) {
      } else {
        this.$message.error("图片插入失败,请检查文件格式");
        return;
      }
    },
    //正文插入图片上传成功调用
    uploadSuccess(response, file, fileList) {
      console.log("response", response);
      this.urlList.push(response.data);
      let quill = this.$refs.myQuillEditor.quill;
      if (response.data != null) {
        console.log("quill.getSelection()", quill.getSelection());
        //获取光标所在位置
        let length = quill.getSelection().index;
        //插入图片
        quill.insertEmbed(length, "image", response.data);
        //移动光标到图片后
        quill.setSelection(length + 1);
      }
    },
    // 失去焦点事件
    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },

    async getCompant() {
      const res = await getCompanyList();
      this.conpmanyOptions = res.data;
    },
    changeState(val) {
      this.formDataAdd.states = val;
    },
    back() {
      this.$router.go(-1);
    },
    changeCompany(val) {
      console.log(val);
      const res = val.join(",") + "";
      this.nameArr = res;
      console.log(this.nameArr);
    },
    async commit() {
      console.log(this.formDataAdd);
      if (this.formDataAdd.newsName == "") {
        this.$message.error("文章标题不能为空哦！");
        return;
      }
      if (this.formDataAdd.newsId == "") {
        this.$message.error("文章Id不能为空哦！");
        return;
      }

      if (this.formDataAdd.time == "") {
        this.$message.error("发布时间不能为空哦！");
        return;
      }
      if (this.formDataAdd.url == "") {
        this.$message.error("跳转路径不能为空哦！");
        return;
      }
      /*    if (this.formDataAdd.cover_picture == "") {
        this.$message.error("文章封面图片不能为空哦！");
        return;
      }
      if (this.formDataAdd.name_id == "") {
        this.$message.error("文章推送公司不能为空哦！");
        return;
      }
      this.formDataAdd.cover_picture = this.imageUrl;
      this.formDataAdd.name_id = this.nameArr; */
      let res = await addTbArticleList(this.formDataAdd);
      if (res.code == 200) {
        this.$message.success("新增成功");
        setTimeout(() => {
          this.$router.push("/CPIC/articleList");
        }, 500);
      }
      console.log(res);
    },

    cancel() {
      this.$router.push("/CPIC/articleList");
    },

    changeTime(val) {
      const time = this.newDate(val);
      this.formDataAdd.time = time;
    },

    newDate(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
  },
};
</script>

<style scoped>
.ql-container {
  /* // 设置默认字号 */
  font-size: 16px;
  height: 500px;
}

/deep/ .company .el-input--suffix .el-input__inner {
  width: 1000px;
  /* margin-left: 200px; */
}

/* .company{
    width: 110px !important;
} */

.state {
  width: 460px !important;
}

/deep/ .content .el-textarea__inner {
  min-height: 400px !important;
}

.dataPicker {
  width: 460px !important;
}

/* // 给文本内容加高度，滚动条 */
.quill-editor /deep/ .ql-container {
  min-height: 620px;
}

.ql-container {
  min-height: 630px;
}

/deep/ {
  .ql-snow .ql-tooltip [data-mode="link"]::before {
    content: "请输入链接地址:";
    left: 0;
  }

  .ql-snow .ql-tooltip.ql-editing {
    left: 0 !important;
  }

  .ql-snow .ql-tooltip {
    left: 0 !important;
  }

  .ql-snow .ql-editor {
    max-height: 700px;
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }

  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px" !important;
    font-size: 14px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: "10px" !important;
    font-size: 10px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
    content: "12px" !important;
    font-size: 12px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: "16px" !important;
    font-size: 16px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
    content: "18px" !important;
    font-size: 18px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
    content: "20px" !important;
    font-size: 20px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
    content: "30px" !important;
    font-size: 30px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
    content: "32px" !important;
    font-size: 32px;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5" !important;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6" !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体" !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体" !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体" !important;
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
    content: "宋体" !important;
    font-family: "SimSun";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
    content: "黑体" !important;
    font-family: "SimHei";
  }

  .ql-snow
    .ql-picker.ql-font
    .ql-picker-label[data-value="Microsoft-YaHei"]::before,
  .ql-snow
    .ql-picker.ql-font
    .ql-picker-item[data-value="Microsoft-YaHei"]::before {
    content: "微软雅黑" !important;
    font-family: "Microsoft YaHei";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
    content: "楷体" !important;
    font-family: "KaiTi";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
    content: "仿宋" !important;
    font-family: "FangSong";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
    content: "Arial" !important;
    font-family: "Arial";
  }

  .ql-snow
    .ql-picker.ql-font
    .ql-picker-label[data-value="Times-New-Roman"]::before,
  .ql-snow
    .ql-picker.ql-font
    .ql-picker-item[data-value="Times-New-Roman"]::before {
    content: "Times New Roman" !important;
    font-family: "Times New Roman";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
    content: "sans-serif" !important;
    font-family: "sans-serif";
  }

  .ql-font-SimSun {
    font-family: "SimSun";
  }

  .ql-font-SimHei {
    font-family: "SimHei";
  }

  .ql-font-Microsoft-YaHei {
    font-family: "Microsoft YaHei";
  }

  .ql-font-KaiTi {
    font-family: "KaiTi";
  }

  .ql-font-FangSong {
    font-family: "FangSong";
  }

  .ql-font-Arial {
    font-family: "Arial";
  }

  .ql-font-Times-New-Roman {
    font-family: "Times New Roman";
  }

  .ql-font-sans-serif {
    font-family: "sans-serif";
  }

  .ql-snow.ql-toolbar .ql-formats .ql-revoke {
    /* background-image: url("../../../../assets/images/icons8-rotate-left-18.png"); */
    width: 20px;
    height: 20px;
    filter: grayscale(100%);
    opacity: 1;
  }

  .ql-snow.ql-toolbar .ql-formats .ql-revoke:hover {
    /* background-image: url("../../../../assets/images/icons8-rotate-left-18.png"); */
    width: 20px;
    height: 20px;
    filter: none;
    opacity: 0.9;
  }

  img {
    filter: grayscale(100%);
    opacity: 1;
  }

  img:hover {
    filter: none;
    opacity: 0.9;
  }

  /*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*/
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc;
    height: 125px;
    overflow: auto;
  }
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/CPIC/addArticle.vue